export default __webpack_public_path__ + "static/media/icon-calendar.f718873d.svg";